import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface OurServicesCardProps {
  icon: IconProp;
  title: string;
  desc: string;
  color: string;
  borderColor: string;
  id?: string;
}

const OurServicesCard: React.FC<OurServicesCardProps> = ({
  icon,
  title,
  desc,
  color,
  borderColor,
  id,
}) => {
  return (
    <div id={id} className="our-services-card" style={{ borderTop: `5px solid ${borderColor}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
        <FontAwesomeIcon
          className="our-services-card-icon"
          icon={icon}
          style={{ color: color, margin: 0, fontSize: "20px" }}
        />
        <h2 style={{ margin: 0, lineHeight: "1.2" }}>{title}</h2>
      </div>
      <span>{desc}</span>
    </div>
  );
};

export default OurServicesCard;
